import Popper from '@di-shared/features/common/Popper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import React from 'react';
import {emitEventLog} from '@di-shared/features/analytics';

function BatteryDischargeEstimatorTooltip() {
  const {t} = useInferableTranslation();

  return (
    <Popper
      placement="bottom"
      className="tooltip"
      marginLeft={3}
      onOpen={() =>
        emitEventLog({
          event: 'vehicle_status_check',
          interaction_type: 'tooltip click',
          click_text: t('T30080'),
          click_location: 'body',
        })
      }
      tooltip={
        <div
          tabIndex={0}
          role="tooltip"
          id="tooltipBox01"
        >
          <strong className="tooltip_title">{t('T30080')}</strong>
          <ul className="tooltip_list">
            <li className="tooltip_item">{t('T30088')}</li>
          </ul>
          <div className="tooltip_table">
            <table>
              <caption>
                <span className="blind">{t('T30080')}</span>
              </caption>
              <colgroup>
                <col style={{width: '80px'}} />
                <col
                  style={{
                    width: '160px',
                  }}
                />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">{t('T30089')}</th>
                  <th scope="col">{t('T30365')}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">{t('T30090')}</th>
                  <td>{t('T30091')}</td>
                </tr>
                <tr>
                  <th scope="row">{t('T30092')}</th>
                  <td>{t('T30082_$days', {days: '1~5'})}</td>
                </tr>
                <tr>
                  <th scope="row">{t('T30093')}</th>
                  <td>{t('T30081_$days_#short', {days: 5})}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      }
    >
      <div className="tooltip_area tooltip_area_single">
        <button
          type="button"
          className="btn_tooltip"
          aria-describedby="tooltipBox01"
          aria-controls="tooltipStatement01"
          aria-expanded="false"
        >
          <span
            className="ic ic_information_16px"
            aria-hidden="true"
          />
        </button>
      </div>
    </Popper>
  );
}

export default BatteryDischargeEstimatorTooltip;
